import {inject, Injectable} from '@angular/core';
import {ActorId, IServerApi, Topic} from '@service-and-repairs/awpintegrationlib';
import {AuthenticationTokenBearerService} from '../auth/authentication-token-bearer.service';
import {ConfigurationLoader} from "../core/configuration/services/configuration.loader";
import {ServiceCaseHolder} from '../core/service-case/models/service-case-holder';
import {SupportInformationService} from '../core/support/support-information.service';
import {UserService} from '../core/user/services/user.service';
import {AwpClientLibService} from './awp-client-lib.service';

@Injectable({
  providedIn: 'root'
})
export class AwpClientLibRepublishService {
  private readonly serviceCaseHolder: ServiceCaseHolder = inject(ServiceCaseHolder);
  private readonly userService: UserService = inject(UserService);
  private readonly supportInformationService: SupportInformationService = inject(SupportInformationService);
  private readonly authenticationTokenBearerService: AuthenticationTokenBearerService = inject(AuthenticationTokenBearerService);
  private readonly configurationLoader: ConfigurationLoader = inject(ConfigurationLoader);
  private readonly libService: AwpClientLibService = inject(AwpClientLibService);

  private readonly awpLib: IServerApi;

  constructor() {
    this.awpLib = this.libService.serverApi;
  }

  public init(): void {
    this.awpLib.subscribeToRequestToRepublish(
      (topic: Topic, destination: ActorId): void => this.handleRepublishRequest(topic, destination)
    );
  }

  private handleRepublishRequest(topic: Topic, destination: ActorId): void {
    if (topic === Topic.ACTIVE_CASE) {
      this.awpLib.publishActiveCase(this.serviceCaseHolder.getActiveCase(), destination);
    } else if (topic === Topic.ACTIVE_USER) {
      this.awpLib.publishActiveUser(this.userService.getCurrentUser(), destination);
    } else if (topic === Topic.OIDC_TOKEN) {
      this.awpLib.publishOidcToken(
        this.authenticationTokenBearerService.oidcTokenSubject.getValue().toLibToken(), destination);
    } else if (topic === Topic.SUPPORT_INFORMATION) {
      this.publishSupportInformation();
    } else if (topic === Topic.OUTLET_CONFIGURATION) {
      this.awpLib.publishOutletConfiguration({
        dmsConfiguration: this.configurationLoader.getDmsConfiguration()
      })
    }
  }

  private publishSupportInformation(): void {
    this.awpLib.publishSupportInformation(
      this.supportInformationService.collectSupportInformation(
        this.userService.getCurrentUser()
      ));
  }
}
